<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-13
 * @Description: 营销管理/平台营销工具/平台卡券活动/领取记录
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search ref="YkcSearch" :data="searchItems" @click="handleSearchConfirm" />
    </template>
    <ykc-table
      ref="YkcTable"
      :data="tableData"
      :columns="tableColumns"
      :title="tableTitle"
      :operateButtons="tableOperateButtons">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button type="plain" @click="exportBlob">导出</ykc-button>
        </div>
      </template>
      <ykc-pagination
        slot="pagination"
        ref="YkcPagination"
        :total="total"
        :current-page.sync="currentPage"
        @current-change="handlePaginationCurrentChange"
        :page-size.sync="pageSize"
        @size-change="handlePaginationSizeChange" />
    </ykc-table>
  </scroll-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { couponActivity } from '@/service/apis';
  import { offlineExport } from '@/utils'; // 新增/编辑组件

  export default {
    name: 'platformCouponActivity',
    components: {},
    computed: {
      ...mapGetters([]),
    },
    data() {
      return {
        activityId: '',
        pageButtons: [
          {
            id: '1',
            text: '导出',
            type: 'plain',
            handleClick: () => {
              this.exportBlob();
            },
          },
        ],
        /**
         * 查询数据
         */
        searchItems: [
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'collectioTime',
            label: '领取时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '领取用户',
            placeholder: '请输入领取用户',
          },
          {
            comName: 'YkcInput',
            key: 'userOrgName',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
          {
            comName: 'YkcInput',
            key: 'activityName',
            label: '活动名称',
            placeholder: '请输入活动名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'activityType',
            label: '活动类型',
            placeholder: '请选择活动类型',
            data: this.dicTypes(),
          },
        ],
        tableData: [],

        tableColumns: [
          { label: '领取用户', prop: 'userAccount' },
          { label: '归属客户', prop: 'userOrgName' },
          { label: '用户分组', prop: 'userGroupName' },
          { label: '活动名称', prop: 'activityName' },
          {
            label: '活动类型',
            prop: 'activityType',
            scopedSlots: {
              default: ({ row }) => {
                const idTypes = this.dicTypes();
                if (!row.activityType) {
                  return '——';
                }
                const type = idTypes.filter(item => item.id === row.activityType)[0] || {};
                return type.name || '——';
              },
            },
          },
          { label: '承担方', prop: 'activityInitiatorText' },
          { label: '参与时间', prop: 'receiveTime' },
        ],
        tableTitle: '领取记录清单',
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
    },
    /// 生命周期
    created() {
      this.activityId = this.$route.query.activityId || '';
      this.getData();
    },
    methods: {
      dicTypes() {
        // 活动类型(1:注册领取，2:充值领取，3:定向发放，4:充电领取，5:扫码领取，6:券码兑换)
        return [
          { id: '1', name: '注册领取' },
          { id: '2', name: '充值领取' },
          { id: '3', name: '定向发放' },
          { id: '4', name: '充电领取' },
          { id: '5', name: '扫码领取' },
          { id: '6', name: '券码兑换' },
        ];
      },
      /**
       * 点击查询
       * @param form
       */
      handleSearchConfirm(form) {
        this.currentPage = 1;
        const search = JSON.parse(JSON.stringify(form));
        if (search.collectioTime && search.collectioTime.length === 2) {
          [search.receiveTimeStart, search.receiveTimeEnd] = search.collectioTime;
        }

        delete search.receiveTimeStart;
        delete search.receiveTimeEnd;
        this.searchParams = search || {};
        this.getData();
      },
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
        console.log('列表按钮点击事件', button, event);
      },
      /**
       * 导出
       */
      exportBlob() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'cardCouponActivityReceiveRecordList',
            activityInitiator: '2',
            activityId: this.activityId || '',
            ...this.searchParams,
          },
        });
      },

      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.currentPage = current;
        this.getData();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.getData();
      },
      /**
       * @desc 获取数据
       * */
      getData() {
        const reqData = {
          ...(this.searchParams || {}),
          activityInitiator: '2',
          current: this.currentPage,
          size: this.pageSize,
        };
        reqData.activityId = this.activityId || '';
        couponActivity.couponReceiveRecord(reqData).then(res => {
          this.tableData = res.records || [];
          this.total = res.total;
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
